// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__2gMyh","label":"Chart_label__2ZooC"};